module.exports = __webpack_public_path__ + "img/icon-more.844cba5d.svg";